module.exports = __webpack_public_path__ + "img/norwich-city.0e7b2fe1.png";